<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="[$t('questionsdetailview.unit_singular'), $t('questionsdetailview.unit_plural'), $t('questionsdetailview.unit_new')]"
			:pagination="pagination"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			@toggleAdd="toggleAddQuestion"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns" @click="closeAdd()">
			<QuestionList
				:questions="questions"
				:questionGroup="questionGroup"
				@delete="askToDeleteQuestion"
				@edit="editQuestion"
				@search="getQuestions()"
			/>
		</main>
		<addQuestion
			v-if="showAddQuestion"
			@cancel="closeAdd"
			@save="saveQuestion"
			:editQuestion="selectedQuestion"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import QuestionList from './components/QuestionList';
import AddQuestion from './modals/AddQuestion';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		QuestionList,
		AddQuestion,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAddQuestion: false,
			showDelete: false,
			selectedQuestion: {},
		};
	},
	computed: {
		...mapState('questionStore', ['searchParams']),
		...mapGetters('questionStore', ['questions', 'pagination']),
		...mapGetters('questionGroupStore', ['questionGroup']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedQuestion.name
				? this.$t('questionsdetailview.confirm_delete', { name: this.selectedQuestion.name })
				: '';
		},

		orderBys() {
			return [
				{ name: this.$t('common.order_name'), value: 'Name' },
				{ name: this.$t('common.order_created'), value: 'Created' }
			];
		},
	},

	watch: {
		'getActiveCustomer.id'() {
			this.$router.push({ name: 'QuestionsView' });
		}
	},

	methods: {
		...mapActions('questionStore', [
			'setQuestion',
			'getQuestions',
			'createQuestion',
			'updateQuestion',
			'deleteQuestion',
			'setCurrentPage',
			'setPageSize'
		]),
		...mapActions('questionGroupStore', ['getQuestionGroup']),
		toggleAddQuestion() {
			this.showAddQuestion = !this.showAddQuestion;
			this.selectedQuestion = {};
		},
		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAddQuestion = false;
				this.selectedQuestion = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedQuestion = {};
			}
		},
		askToDeleteQuestion(question) {
			this.showAddQuestion = false;
			Object.assign(this.selectedQuestion, question);
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
		},
		deleteSelected() {
			this.deleteQuestion(this.selectedQuestion).then(() => {
				this.getQuestions();
				this.showDelete = false;
			});
		},
		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getQuestions();
		},
		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getQuestions();
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.getQuestions();
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.getQuestions();
		},
		saveQuestion(question) {
			if (this.selectedQuestion.id) {
				this.updateQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.selectedQuestion = {};
					this.getQuestions();
				});
			} else {
				question.questionGroupId = this.$router.params.questionGroupId;
				this.createQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.getQuestions();
				});
			}
		},
		editQuestion(question) {
			if (this.selectedQuestion == question) {
				this.selectedQuestion = {};
				this.showAddQuestion = false;
			} else {
				this.selectedQuestion = question;
				this.showAddQuestion = true;
			}
		}
	},
	created() {

		this.searchParams.questionGroupId = this.$route.params.questionGroupId;
		this.getQuestions();
		this.getQuestionGroup(this.$route.params.questionGroupId);
	}
};
</script>
